import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { InviteVerifyPage } from "@/features/invitee/verify";

export const Route = createFileRoute("/(member)/(public)/invite/$token/verify")(
  {
    component: InviteVerifyPage,
    validateSearch: z.object({
      method: z.enum(["email", "phone"]).optional(),
      email: z.email().optional(),
      phone: z.string().optional(),
      id: z.string().optional(),
      firstName: z.string().optional(),
      lastName: z.string().optional(),
    }),
    head: () => ({
      meta: [
        { title: "Birdwatch - Verify" },
        {
          name: "description",
          content: "Verify your account to accept your Birdwatch invite",
        },
      ],
    }),
  },
);
